module.exports = __webpack_public_path__ + "img/1.a51e7c9f.jpg";